import { ConfigFullContext } from '../context/ConfigFullContext';
import ConfigContext from '../context/ConfigContext';
import { useContext } from 'react';

export function useConfiguration() {
	const publicConfig = useContext(ConfigContext);
	const fullConfig = useContext(ConfigFullContext);

	return fullConfig ?? publicConfig;
}